import { useMemo } from 'react';
import { toString, uniqBy } from 'lodash';

import { useContactListQuery } from '@/modules/employer/components/SetupEmployer/ContactsSecurity/AddEditContactsSecurityModal/queries/useContacts.queries';
import useContactInfoQuery from '@/modules/user/queries/useContactInfo.query';

interface Props {
  contactId?: string;
  organizationId?: string;
}

const useGetContactsAndByIdQuery = ({ contactId, organizationId }: Props) => {
  const { formattedData: contact, isLoading: isContactLoading } = useContactInfoQuery(contactId);
  const { contactList, isLoading: isContactListLoading } = useContactListQuery({ organizationId, size: 200, });

  const contactListOptions = useMemo(() => {
    const contactOption = {
      key: toString(contact?.id),
      value: toString(contact?.id),
      title: `${contact?.firstName} ${contact?.lastName}`,
    };

    const contactListOptions = contactList?.map((contact) => ({
      key: toString(contact?.id),
      value: toString(contact?.id),
      title: `${contact?.first_name} ${contact?.last_name}`,
    }));

    const allContactsOptions = [contactOption, ...contactListOptions];
    return uniqBy(allContactsOptions, 'key');
  }, [contact, contactList]);

  const isLoading = useMemo(() => isContactLoading || isContactListLoading, [isContactLoading, isContactListLoading]);
  
  return {
    contactListOptions: isLoading ? [] : contactListOptions,
    isLoading,
  }
};

export default useGetContactsAndByIdQuery;
